<p-card>
  <ng-template #title>{{ "measurement.insight.title" | translate }}</ng-template>
  <ng-template #subtitle>{{ "measurement.insight.subtitle" | translate }}</ng-template>

  <!-- __MATURITY__ -->
  @if (config()?.visualizationConfig?.maturityThreshold?.app) {
    <div>
      @if (currentMaturity() != null) {
        <p>
          <span class="h2">
            <span>{{ currentMaturity() | number:'1.2-2' }} {{ "measurement.insight.maturity_days" | translate }}</span>
          </span>
          <small>
            {{ currentMaturity()! * 24 | number:'1.2-2' }} {{ "measurement.insight.maturity" | translate }} -
            {{ "measurement.insight.curr_maturity" | translate }}
          </small>
        </p>
      }
      @if (specifications_maturity() != null && specifications_maturity()!.length) {
        <div>
          <p class="h6">
            @if (currentMaturity() && currentMaturity()! < specifications_maturity()![specifications_maturity()!.length - 1]) {
              <span style="color:red;">{{ "measurement.insight.not_reached" | translate }}</span>
            }
            @if (currentMaturity() && currentMaturity()! > specifications_maturity()![specifications_maturity()!.length - 1]) {
              <span style="color:green;">{{ "measurement.insight.reached" | translate }}</span>
            }
          </p>
          <p class="h6">
            {{ "measurement.insight.maturity_at" | translate }}
            @if (currentMaturity()) {
              <span>{{ currentMaturity() | number:'1.2-2' }}</span>
            }
            {{ "measurement.insight.out_of" | translate }} {{ specifications_maturity()![specifications_maturity()!.length - 1] | number:'1.0-2' }} {{ "measurement.insight.maturity_days" | translate }}
          </p>
          @if (specifications_maturity()!.length === 1) {
            <p-progressbar
              class="mb-3"
              color="primary"
              [value]="100 * currentMaturity()! / specifications_maturity()![specifications_maturity()!.length - 1]"
              [showValue]="false"
            ></p-progressbar>
          }
          <div class="strength-checkpoints-container">
            @for (checkpoint of specifications_maturity(); track checkpoint; let i = $index; let first = $first; let last = $last) {
              @if (first && !last) {
                <div class="strength-checkpoint"
                  [ngClass]="{'reached': currentMaturity()! > checkpoint}"
                  [style.width.%]="100 * checkpoint / specifications_maturity()!.at(-1)!">
                  {{ checkpoint }} {{ "measurement.insight.maturity_days" | translate }}
                </div>
              }
              @if (!first) {
                <div class="strength-checkpoint"
                  [ngClass]="{'reached': currentMaturity()! > checkpoint}"
                  [style.width.%]="100 * (checkpoint - specifications_maturity()![i - 1]) / specifications_maturity()!.at(-1)!">
                  {{ checkpoint }} {{ "measurement.insight.maturity_days" | translate }}
                </div>
              }
              @if (first && last) {
                <div class="strength-checkpoint last-checkpoint"
                  [ngClass]="{'reached': currentMaturity()! > checkpoint}">
                  {{ checkpoint }} {{ "measurement.insight.maturity_days" | translate }}
                </div>
              }
            }
          </div>
        </div>
      }
      <p-divider></p-divider>
    </div>
  }

  <!-- __RELATIVE MATURITY__ -->
  @if (config()?.visualizationConfig?.relativeMaturityThreshold?.app) {
    <div>
      @if (currentRelativeMaturity() != null) {
        <p>
          <span class="h2">
            <span>{{ currentRelativeMaturity() | number:'1.2-2' }} {{ "measurement.insight.maturity_days" | translate }}</span>
          </span>
          <small>
            {{ currentRelativeMaturity()! * 24 | number:'1.2-2' }} {{ "measurement.insight.maturity" | translate }} -
            {{ "measurement.insight.curr_relative_maturity" | translate }}
          </small>
        </p>
      }
      @if (specifications_relative_maturity() != null && specifications_relative_maturity()!.length) {
        <div>
          <p class="h6">
            @if (currentRelativeMaturity() && currentRelativeMaturity()! < specifications_relative_maturity()![specifications_relative_maturity()!.length - 1]) {
              <span style="color:red;">{{ "measurement.insight.not_reached" | translate }}</span>
            }
            @if (currentRelativeMaturity() && currentRelativeMaturity()! > specifications_relative_maturity()![specifications_relative_maturity()!.length - 1]) {
              <span style="color:green;">{{ "measurement.insight.reached" | translate }}</span>
            }
          </p>
          <p class="h6">
            {{ "measurement.insight.maturity_relative_at" | translate }}
            @if (currentRelativeMaturity()) {
              <span>{{ currentRelativeMaturity() | number:'1.2-2' }}</span>
            }
            {{ "measurement.insight.out_of" | translate }} {{ specifications_relative_maturity()![specifications_relative_maturity()!.length - 1] | number:'1.0-2' }} {{ "measurement.insight.maturity_days" | translate }}
          </p>
          @if (specifications_relative_maturity()!.length === 1) {
            <p-progressbar
              class="mb-3"
              color="primary"
              [value]="100 * currentRelativeMaturity()! / specifications_relative_maturity()![specifications_relative_maturity()!.length - 1]"
              [showValue]="false"
            ></p-progressbar>
          }
          <div class="strength-checkpoints-container">
            @for (checkpoint of specifications_relative_maturity(); track checkpoint; let i = $index; let first = $first; let last = $last) {
              @if (first && !last) {
                <div class="strength-checkpoint"
                  [ngClass]="{'reached': currentRelativeMaturity()! > checkpoint}"
                  [style.width.%]="100 * checkpoint / specifications_relative_maturity()!.at(-1)!">
                  {{ checkpoint }} {{ "measurement.insight.maturity_days" | translate }}
                </div>
              }
              @if (!first) {
                <div class="strength-checkpoint"
                  [ngClass]="{'reached': currentRelativeMaturity()! > checkpoint}"
                  [style.width.%]="100 * (checkpoint - specifications_relative_maturity()![i - 1]) / specifications_relative_maturity()!.at(-1)!">
                  {{ checkpoint }} {{ "measurement.insight.maturity_days" | translate }}
                </div>
              }
              @if (first && last) {
                <div class="strength-checkpoint last-checkpoint"
                  [ngClass]="{'reached': currentRelativeMaturity()! > checkpoint}">
                  {{ checkpoint }} {{ "measurement.insight.maturity_days" | translate }}
                </div>
              }
            }
          </div>
        </div>
      }
      <p-divider></p-divider>
    </div>
  }

  <!-- __STRENGTH__ -->
  <p>
    <span class="h2">
      @if (currentStrength() != null) {
        <span>{{ currentStrength() | number:'1.1-1' }}</span>
      }
      {{ "measurement.insight.mpa" | translate }}
    </span>
    <small>{{ "measurement.insight.curr_strength" | translate }}</small>
  </p>
  @if (specifications() != null && specifications()!.length) {
    <div>
      <p class="h6">
        @if (currentStrength() && currentStrength() < specifications()![specifications()!.length - 1]) {
          <span style="color:red;">{{ "measurement.insight.not_reached" | translate }}</span>
        }
        @if (currentStrength() && currentStrength() > specifications()![specifications()!.length - 1]) {
          <span style="color:green;">{{ "measurement.insight.reached" | translate }}</span>
        }
      </p>
      <p class="h6">
        {{ "measurement.insight.strength_at" | translate }}
        @if (currentStrength()) {
          <span>{{ currentStrength() | number:'1.1-1' }}</span>
        }
        {{ "measurement.insight.out_of" | translate }} {{ specifications()![specifications()!.length - 1] | number:'1.1-1' }} {{ "measurement.insight.mpa" | translate }}
      </p>
      @if (specifications()!.length >= 1) {
        <p-progressbar
          class="mb-3"
          color="primary"
          [value]="100 * currentStrength() / specifications()![specifications()!.length - 1]"
          [showValue]="false"
        ></p-progressbar>
      }
      <div class="strength-checkpoints-container">
        @for (checkpoint of specifications(); track checkpoint; let i = $index; let first = $first; let last = $last) {
          @if (first && !last) {
            <div class="strength-checkpoint"
              [ngClass]="{'reached': currentStrength() > checkpoint}"
              [style.width.%]="100 * checkpoint / specifications()!.at(-1)!">
              {{ checkpoint }}MPa
            </div>
          }
          @if (!first) {
            <div class="strength-checkpoint"
              [ngClass]="{'reached': currentStrength() > checkpoint}"
              [style.width.%]="100 * (checkpoint - specifications()![i - 1]) / specifications()!.at(-1)!">
              {{ checkpoint }}MPa
            </div>
          }
          @if (first && last) {
            <div class="strength-checkpoint last-checkpoint"
              [ngClass]="{'reached': currentStrength() > checkpoint}">
              {{ checkpoint }}MPa
            </div>
          }
        }
      </div>
    </div>
  }

  <p-divider></p-divider>

  <p class="mt-4">
    {{ 'measurement.lastSeen' | translate }}:
    @if (currentTime()) {
      <span>{{ currentTime() | date:'dd/MM/yyyy HH:mm:ss' }}</span>
    } @else {
      <span>{{ 'measurement.insight.no_data' | translate }}</span>
    }
  </p>
</p-card>
